import { FcMissedCall } from "react-icons/fc";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { LiaVoicemailSolid } from "react-icons/lia";
import { useDispatch, useStore } from "react-redux";

import { formatRelativeDate } from "../../../../../services/helper";
import { colors } from "../../../../../utils/constants/colors";
import { modifyNotification } from "../../../../../redux/actions/notification";
import { toast } from "../../../../CommonComponents/ToastComponent/toast";
import { useContext, useState } from "react";
import { Modal } from "rsuite";
import { AppContext } from "../../../../../context";


const MissedCall = ({ key, notification, currentPage, setCurrentPage, subTab, setSelectedNotification, setCheckedKeys, getNotificationsUnifiedHandler, searchValue, limit, offset, filterValue, isCancelledRef }) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const {
        getNewUnreadNotification,
        notificationCheckbox
    } = useContext(AppContext);

    const [checked, setChecked] = useState(false)

    const store = useStore().getState();
    const { auth } = store;

    const onDetailHandler = async () => {
        let notificationIds = []
        notificationIds.push(notification?.notificationId)
        const updateResult = await dispatch(modifyNotification(notificationIds, "markAsRead", 'missedCalls')).then((res) => res).catch((err) => {
            if (err) {
                toast.show({
                    title: 'Danger',
                    description: 'Unable To Modify From Unread To Read'
                })
            }
        })
        setCurrentPage('notificationDetail')
        history.push(`/tasks/notifications/missedCallDetail?callSid=${notification?.callSid}`)
    }

    const checkHandler = (checked) => {
        setChecked(checked)
        checked ? setCheckedKeys(prevState => [...prevState, notification?.notificationId]) : setCheckedKeys(prevState => prevState?.filter(id => id !== notification?.notificationId))
    }

    let time = formatRelativeDate(notification?.calledAt)

    return (
        <div key={key} className={`container-fluid py-2 py-3 d-flex column-gap-3 mb-3 rounded ${!notification?.isRead && 'border'}`} style={{ backgroundColor: notification?.isRead ? "aliceblue" : "#fff" }}>
            <div className="d-flex column-gap-4 col-1 align-items-center">
                <button className="rounded-circle border p-2" style={{ width: '50px', height: '50px' }}><FcMissedCall size={25} /></button>
                <input type="checkbox" style={{ width: 15, height: 15 }} onChange={(e) => { checkHandler(e?.target?.checked, notification?.id) }} checked={checked} />
            </div>
            <div className="d-flex col-11 column-gap-2">
                <div className="col-2  align-self-center">
                    {notificationCheckbox ? 
                    <p className="m-0 fs-4  text-black">{notification?.firstname + " " + notification?.lastname}</p> :
                    <p className="m-0 fs-4  text-black">{auth?.user?.firstname + " " + auth?.user?.lastname}</p>}
                </div>
                <div className="col-2  align-self-center">
                    {
                        !notification?.contactId ?
                            <p
                                className="m-0 fs-4"
                                style={{ fontSize: 14, color: colors.linkBlue }}
                            >
                                {notification?.externalNumber}
                            </p> :
                            <Link
                                to={`/contacts/${notification?.contactId}`}
                                className="m-0 fs-4"
                                style={{ fontSize: 14, color: colors.linkBlue }} target='_blank'
                            >
                                {notification?.externalNumber}
                            </Link>
                    }
                </div>
                <div className="col-2  align-self-center">
                    <p className="m-0 fs-4 " style={{ fontSize: 14 }}>{time}</p>
                </div>
                <div className="col-1  align-self-center">
                    <p className="m-0 fs-4 " style={{ fontSize: 14 }}>{notification?.isVoicemail ? <LiaVoicemailSolid size={25} /> : null}</p>
                </div>
                <div className="col-2  align-self-center ">
                    <p className="m-0 fs-4 " style={{ fontSize: 14 }}>{notification?.isConnected ? 'Connected' : `Didn't Connect`}</p>
                </div>
                {notification?.isVoicemail && <div className="col-2 fs-4 align-self-center text-start">
                    <button className="report_small_button_success" onClick={onDetailHandler}>Details</button>
                </div>}
            </div>
        </div>
    )
}

export default MissedCall